export { default as createInfiniteHitsSessionStorageCache } from "./sessionStorage.js";